
























































































































































import Vue, { PropType } from 'vue';
// import { CompanyData } from '@/modules/exhibitor/company';
import {
  ExhibitorCompanyData as CompanyData,
  // firebase,
  // calender,
} from 'mostra';

export default Vue.extend({
  name: 'GAccountCompany',
  props: {
    company: {
      type: Object as PropType<CompanyData>,
      default: () => ({}),
    },
  },
});
